import React, { useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import { AfDataType } from "utils/TableColumnData";
import handleWheel from "utils/handleOnWheel";
import { CreateCommanWay, GetCommanWay, ListCommanWay, UpdateCommanWay, UpdateBookingCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { Img } from "components";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { object } from "yup";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import { roles } from "utils/constant";
import Spinner from "utils/Spinner";
import { set } from "lodash";
import { AfDateRangePicker } from "components/Input/AfDateRangePicker";
import { AddCollection } from "./AddCollection";
import { Checkbox } from "@heroui/react";
import { PaperAirplaneIcon } from "@heroicons/react/24/outline";

const InvoiceReport: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const navigator = useNavigate();
  const [tableData, setTableData] = useState<any>([]);
  const [totals, setTotals] = useState<any>({});
  const [agentId, setAgentId] = useState("");
  const [startDate, setStartDate] = useState<any>(moment().startOf("day").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState<any>(moment().endOf("day").format("YYYY-MM-DD"));
  const [invoiceDate, setInvoiceDate] = useState<any>(moment().startOf("month").format("YYYY-MM-DD"));

  const [editInvoiceDate, setEditInvoiceDate] = useState<any>(moment().startOf("month").format("YYYY-MM-DD"));
  const [editAwbNumbers, setEditAwbNumbers] = useState<any>("");
  const [editInvoiceId, setEditInvoiceId] = useState<any>(0);

  const [selectedInvoice, setSelectedInvoice] = useState<any>([]);

  let date1 = startDate;
  let date2 = endDate;

  const [query, setQuery] = useState<any>({
    $or: [
      { fromDate: { $between: [date1, date2] } },
      { toDate: { $between: [date1, date2] } },
      { fromDate: { $lte: date1 }, toDate: { $gte: date2 } },
    ],
    customerId: { $ne: "" },
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [isDataAdded, setIsDataAdded] = useState(false);

  const [nestedTables, setNestedTables] = useState<any>({});
  const [nestedSelectedOptions, setNestedSelectedOptions] = useState<any>({});

  const [selectedCustomer, setBranchOtp] = useState<any>();
  const [customerList, setcustomerList] = useState<any>([{ value: 0, label: "Loading..." }]);

  const defaultOptions: any = [{ value: 0, label: "Loading..." }];
  const [excelLink, setExcelLink] = useState<any>("");

  const {
    error: branchError,
    isFetching: branchIsFetching,
    isError: branchIsError,
    isFetched: branchIsFetched,
    isLoading: branchIsLoading,
    refetch: branchRefetch,
  } = useQuery(["CustomersListApi"], () => ListCommanWay("/admin/customer/list", { isActive: true }, { paginate: 1000 }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        let opt = [];
        data.data.data.forEach((p) => {
          opt.push({
            value: Number(p.id),
            label: p.code + " - " + p.sh,
          });
        });
        setcustomerList(opt);
      }
    },
  });

  const { isFetching, isLoading, refetch } = useQuery(
    ["admin_invoice_report_list"],
    () =>
      ListCommanWay(
        "/admin/inovic_for_c_b/list",
        {
          ...query,
        },
        { include: ["_customerId", "_subbranch"], paginate: 10000 }
      ),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          console.log("data.data", data.data.data);
          setTableData(data.data.data);

          let ary = [...data.data.data];
          let ttt = {
            base: 0,
            cgst: 0,
            sgst: 0,
            igst: 0,
            grand: 0,

            fuel: 0,
            chc: 0,
          };
          ary.forEach((a) => {
            console.log(a.base_value);
            ttt.base += Number(a.base_value || 0);
            ttt.cgst += Number((a.total_d_tax * 9) / 100);
            ttt.sgst += Number((a.total_d_tax * 9) / 100);
            ttt.igst += Number((a.total_i_tax * 18) / 100);
            ttt.grand += Number(a.total_value || 0);

            ttt.fuel += Number(a.total_chcRate || 0);
            ttt.chc += Number(a.total_fuelRate || 0);
          });
          setTotals(ttt);
        } else {
          setTableData([]);
        }
      },
      onError: (data) => {
        setTableData([]);
      },
    }
  );

  const { mutate: mutateSendInvoice, isLoading: sendInvoiceLoading } = useMutation(
    (data: { customerId: number; invoice_no_c_b: number }) =>
      UpdateBookingCommanWay({
        url: "/admin/inovic_for_c_b/sendCustomerInvoice",
        data: {},
        query: { customerId: data.customerId, invoice_no_c_b: data.invoice_no_c_b },
        options: {},
      }),
    {
      onSuccess: (data: any) => {
        if (data.status == "SUCCESS") {
          UseToast("Invoice sent successfully", "success");
          __handleSubmit();
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  const { mutate: mutateRegenInvoice, isLoading: invoiceRengenLoading } = useMutation(
    (invId) => GetCommanWay("/admin/customer/reinvoice/" + invId, {}, {}),
    {
      onSuccess: (data: any) => {
        console.log(data, data.status == "SUCCESS");
        if (data.status == "SUCCESS") {
          UseToast("Invoice Regenrated successfully", "success");
          __handleSubmit();
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  // Retry IRN for invoices
  const { mutate: mutateRetryIRN, isLoading: retryIRNLoading } = useMutation(
    (invoiceIds: number[]) =>
      CreateCommanWay({
        url: "/admin/booking/retryIRN",
        data: { invoice_ids: invoiceIds },
      }),
    {
      onSuccess: (data: any) => {
        if (data.status == "SUCCESS") {
          const result = data.data;
          if (result.success?.length > 0) {
            UseToast(`IRN activated for ${result.success.length} invoice(s)`, "success");
          }
          if (result.failed?.length > 0) {
            result.failed.forEach((f: any) => {
              UseToast(`IRN failed for invoice ${f.id}: ${f.error}${f.portion ? ` (${f.portion})` : ""}`, "error");
            });
          }
          __handleSubmit();
        } else {
          UseToast(data.message || "Retry failed", "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  useEffect(() => {
    refetch();
  }, [query]);

  const { mutate: mutateGenerateInvoice, isLoading: invGenLoading } = useMutation(
    (invDate) =>
      ListCommanWay(
        "/admin/customer/invoice-gen",
        {
          startDate: moment(startDate).startOf("day").format("YYYY-MM-DD HH:mm:ss"),
          endDate: moment(endDate).endOf("day").format("YYYY-MM-DD HH:mm:ss"),
          invoiceDate: invDate,
          customer: selectedCustomer?.value,
        },
        {}
      ),
    {
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          UseToast("Invoice Generated Successfully", "success");
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  const { mutate: mutateEditInvoice, isLoading: editInvGenLoading } = useMutation(
    (data: any) =>
      ListCommanWay(
        "/admin/customer/invoice-edit",
        {
          invoiceDate: data.invoiceDate,
          awbNumbers: data.awbNumbers,
          invoiceId: data.invoiceId,
        },
        {}
      ),
    {
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          UseToast("Invoice Updated Successfully", "success");
          setEditInvoiceId(0);
          setEditInvoiceDate("");
          setEditAwbNumbers("");
          __handleSubmit();
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  const { mutate: mutateGenerateExcel, isLoading: excelGenLoading } = useMutation(
    (data: any) => ListCommanWay("https://credit-excel-gen-cnb3gdf4dwdxb6fn.centralindia-01.azurewebsites.net/api/HttpTrigger1", data, {}),
    {
      onSuccess(data) {
        console.log(data);
        if (data.status == "SUCCESS" || data.statusText == "OK") {
          setExcelLink(data.data?.url || "");
          Swal.fire({
            title: "File Ready!",
            text: "Click below to download your Excel file.",
            icon: "success",
            showCancelButton: true,
            confirmButtonText: "Download",
            confirmButtonColor: "#3085d6",
            allowOutsideClick: false,
            preConfirm: () => {
              window.open(data.data?.url, "_blank"); // Open file in new tab
            },
          });
        } else {
          UseToast(data?.data?.message || "Error in Excel", "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  const generateInvoice = async () => {
    if (!selectedCustomer.value || invGenLoading) {
      return;
    }
    Swal.fire({
      title: "Are you sure!",
      icon: "question",
      confirmButtonText: "Confirm",
      showCancelButton: true,
    }).then((x) => {
      if (x.isConfirmed) {
        mutateGenerateInvoice(invoiceDate);
      }
    });
  };

  const __handleSubmit = async () => {
    setIsDataAdded(!isDataAdded);

    let date1 = startDate ? startDate : moment().startOf("day").subtract(7, "days").format("YYYY-MM-DD HH:mm:ss");
    let date2 = endDate ? endDate : moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    setQuery({
      $or: [
        {
          fromDate: {
            $between: [date1, date2],
          },
        },
        {
          toDate: {
            $between: [date1, date2],
          },
        },
        {
          fromDate: {
            $lte: date1,
          },
          toDate: {
            $gte: date2,
          },
        },
      ],
      /*invDate: {
        $gte: moment(invoiceDate).startOf('month').startOf('day'),
        $lte: moment(invoiceDate).endOf('month').endOf('day'),
      },*/
      /*invDate: {
        $gte: startDate ? startDate : moment().startOf("day").subtract(7, "days").format("YYYY-MM-DD HH:mm:ss"),
        $lte: endDate ? endDate : moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
      },*/
      customerId: selectedCustomer?.value || { $ne: "" },
    });

    /*setQuery({
      //agent_id: Number(agentId),
      date: {
        $gte: startDate ? startDate : moment().startOf("day").subtract(7, "days"),
        $lte: endDate ? endDate : moment().endOf("day"),
      },
    });*/
  };

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});
  const tableRef = useRef(null);

  const __exportToExcel = () => {
    const table = tableRef.current;

    const tableClone = table.cloneNode(true);

    const tfoot = tableClone.getElementsByTagName("tfoot");
    if (tfoot.length > 0) {
      tfoot[0].remove();
    }
    const toIgnore = tableClone.querySelectorAll(".ignore-excel");
    if (toIgnore.length > 0) {
      toIgnore[0].remove();
    }

    const ws = utils.table_to_sheet(tableClone);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    Object.keys(ws).forEach((key) => {
      if (key.startsWith("!")) return;

      let cell = ws[key];
      if (cell && cell.h && typeof cell.h === "string") {
        cell.h = null;
      }
      if (cell && cell.l) {
        delete cell.l;
      }
    });

    const wbout = write(wb, { bookType: "xlsx", type: "array" });

    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "Invoice Report.xlsx");
  };

  const exportToExcel = () => {
    const table = tableRef.current;

    const tableClone = table.cloneNode(true);

    const tfoot = tableClone.getElementsByTagName("tfoot");
    if (tfoot.length > 0) {
      tfoot[0].remove();
    }

    // === KEEP YOUR ORIGINAL CODE UNCHANGED ===
    const toIgnore = tableClone.querySelectorAll(".ignore-excel");
    if (toIgnore.length > 0) {
      toIgnore[0].remove();
    }
    // =========================================

    // === NEW: Remove entire columns with class "ignore-export" ===
    const exportIgnoreCells = tableClone.querySelectorAll(".ignore-export");
    const columnsToRemove = new Set<number>();

    exportIgnoreCells.forEach((cell) => {
      const row = cell.parentElement;
      if (!row) return;
      const cells = Array.from(row.cells);
      const colIndex = cells.indexOf(cell as HTMLTableCellElement);
      if (colIndex !== -1) {
        columnsToRemove.add(colIndex);
      }
    });

    if (columnsToRemove.size > 0) {
      const allRows = tableClone.querySelectorAll("tr");
      allRows.forEach((row) => {
        const cells = Array.from(row.cells);
        Array.from(columnsToRemove)
          .sort((a, b) => b - a)
          .forEach((colIndex) => {
            if (cells[colIndex]) {
              (cells[colIndex] as any).remove();
            }
          });
      });
    }
    // ===============================================================

    const ws = utils.table_to_sheet(tableClone);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    Object.keys(ws).forEach((key) => {
      if (key.startsWith("!")) return;

      let cell = ws[key];
      if (cell && cell.h && typeof cell.h === "string") {
        cell.h = null;
      }
      if (cell && cell.l) {
        delete cell.l;
      }
    });

    const wbout = write(wb, { bookType: "xlsx", type: "array" });

    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "Invoice Report.xlsx");
  };

  return (
    <>
      {(invoiceRengenLoading || isLoading || invGenLoading || excelGenLoading || sendInvoiceLoading || retryIRNLoading) && <Spinner />}

      {editInvoiceId > 0 && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black-900 bg-opacity-50">
          <div className="absolute inset-0 " onClick={() => setEditInvoiceId(0)}></div>
          <div className="bg-white rounded-lg p-6 relative max-w-lg w-full">
            <button className="absolute top-4 right-4 text-gray-600 hover:text-black" onClick={() => setEditInvoiceId(0)}>
              &times;
            </button>
            <h2 className="text-xl font-bold mb-4">Edit Invoice Date</h2>
            <label>
              Select Invoice Date:
              <input
                type="date"
                className="w-full mb-4 p-2 border border-gray-300 rounded focus:border-primary"
                value={editInvoiceDate}
                onChange={(e) => setEditInvoiceDate(e.target.value)}
              />
            </label>

            <p className="block mb-2">
              Enter AWBs (comma separated):
              <input
                type="text"
                className="w-full p-2 border border-gray-300 rounded focus:border-primary"
                placeholder="e.g. AWB123, AWB456"
                value={editAwbNumbers}
                onChange={(e) => setEditAwbNumbers(e.target.value)}
              />
            </p>

            <button
              className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 mt-4"
              onClick={() => {
                mutateEditInvoice({
                  invoiceDate: editInvoiceDate,
                  awbNumbers: editAwbNumbers,
                  invoiceId: editInvoiceId,
                });
                //setEditInvoiceId(0);
              }}
            >
              Update Invoice
            </button>
          </div>
        </div>
      )}

      <h1 className="text-center mb-3 mt-3 text-lg font-semibold flex items-center justify-center gap-4">
        Invoice Report <AddCollection invoiceData={""} tableData={tableData} selectedInvoice={selectedInvoice} />
      </h1>
      <div className="px-4  border-[1px] p-2 rounded-md">
        <div className="flex flex-wrap flex-col items-center">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <div className={`items-center gap-2`}>
              <label className="mb-2 text-sm font-semibold text-gray-900">Customer</label>
              <Select
                className={`${false ? "bg-gray-300" : ""} w-72 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                options={customerList}
                onChange={(e) => {
                  setBranchOtp(e);
                }}
                value={selectedCustomer}
                isClearable={true}
              />
            </div>

            <AfDateRangePicker setStartDate={setStartDate} setEndDate={setEndDate} label="From Date - To Date" />

            <div className="">
              <label className="block mb-0.5 text-sm font-medium text-gray-900">Invoice Date</label>
              <input
                type="date"
                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                placeholder="End Date"
                name="invoiceDate"
                value={invoiceDate}
                onChange={(e) => setInvoiceDate(e.target.value)}
              />
            </div>
            <button
              type="button"
              onClick={__handleSubmit}
              className="ml-2 rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
            >
              Submit
            </button>

            <button
              type="button"
              onClick={generateInvoice}
              className="rounded-md px-4 py-2 text-sm font-medium text-white bg-red-700 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
            >
              Generate Invoice
            </button>

            <button onClick={exportToExcel} className=" bg-blue-600 text-white px-4 py-1 rounded-md">
              Excel Export
            </button>
          </div>
        </div>
      </div>

      <div className="px-4">
        <table className="w-full table- mb-8" style={{ fontSize: "85%" }} id="myTable" ref={tableRef}>
          <thead className="sticky top-0 bg-gray-300">
            <tr className="ignore-excel">
              <th className="">-</th>
              <th className="border border-slate-200 px-1">{tableData.length}</th>
              <th className="border border-slate-200 px-1 ignore-export"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>

              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1 py-2">
                {((totals.base || 0) - (totals.fuel || 0) - (totals.chc || 0))?.toLocaleString("en-IN", { maximumFractionDigits: 2 })}
              </th>
              <th className="border border-slate-200 px-1">{totals.chc?.toLocaleString("en-IN", { maximumFractionDigits: 2 })}</th>
              <th className="border border-slate-200 px-1">{totals.fuel?.toLocaleString("en-IN", { maximumFractionDigits: 2 })}</th>
              <th className="border border-slate-200 px-1">{totals.cgst?.toLocaleString("en-IN", { maximumFractionDigits: 2 })}</th>
              <th className="border border-slate-200 px-1">{totals.sgst?.toLocaleString("en-IN", { maximumFractionDigits: 2 })}</th>
              <th className="border border-slate-200 px-1">{totals.igst?.toLocaleString("en-IN", { maximumFractionDigits: 2 })}</th>
              <th className="border border-slate-200 px-1">{totals.grand?.toLocaleString("en-IN", { maximumFractionDigits: 2 })}</th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1 ignore-export"></th>
              <th className="border border-slate-200 px-1 ignore-export">-</th>
            </tr>
            <tr>
              <th className="border border-slate-200 px-1 ignore-export"></th>
              <th className="border border-slate-200 px-1 ignore-export">Sr.</th>
              <th className="border border-slate-200 px-1 ignore-export"></th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Customer</th>
              <th className="border border-slate-200 px-1">Customer Name</th>
              <th className="border border-slate-200 px-1">Invoice no</th>
              <th className="border border-slate-200 px-1">Invoice no(I)</th>
              <th className="border border-slate-200 px-1">Invoice Date</th>
              <th className="border border-slate-200 px-1">From Date</th>
              <th className="border border-slate-200 px-1">To Date</th>
              <th className="border border-slate-200 px-1">Password</th>
              <th className="border border-slate-200 px-1">Amount</th>
              <th className="border border-slate-200 px-1">Fuel</th>
              <th className="border border-slate-200 px-1">CHC</th>
              <th className="border border-slate-200 px-1">CGST</th>
              <th className="border border-slate-200 px-1">SGST</th>
              <th className="border border-slate-200 px-1">IGST</th>
              <th className="border border-slate-200 px-1">Grand Total</th>
              <th className="border border-slate-200 px-1">GST No.</th>              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>              <th className="border border-slate-200 px-1">IRN Status</th>
              <th className="border border-slate-200 px-1">IRN Intl</th>
              <th className="border border-slate-200 px-1 ignore-export">DOWNLOAD</th>
              {userDetails.roleName == roles.SUPER_ADMIN && <th className="border border-slate-200 px-1 ignore-export">Action</th>}
            </tr>
          </thead>
          <tbody>
            {tableData &&
              tableData.map((r, i) => {
                const payResData = typeof r.payRes === "string" ? JSON.parse(r.payRes || "{}") : r.payRes;
                const isMailSent = payResData?.mailSent === true;
                return (
                  <tr key={"r123" + r.id} className={`${isMailSent ? "bg-blue-300" : !r.isActive ? "bg-red-200" : ""} hover:bg-yellow-100`}>
                    <th className="border border-slate-200 px-1 text-center">
                      <Checkbox
                        isSelected={selectedInvoice.includes(r.id)}
                        onValueChange={() => {
                          if (selectedInvoice.includes(r.id)) {
                            setSelectedInvoice(selectedInvoice.filter((id) => id !== r.id));
                          } else {
                            setSelectedInvoice([...selectedInvoice, r.id]);
                          }
                        }}
                      ></Checkbox>
                    </th>
                    <td className="border border-slate-200 px-2 text-center">{i + 1}</td>
                    {userDetails.roleName == roles.SUPER_ADMIN && (
                      <td className="border border-slate-200 px-2 text-center">
                        <button
                          onClick={() => {
                            Swal.fire({
                              title: "Are you sure?",
                              html: `
                                <div style="text-align: left;">
                                  <p><strong>Customer:</strong> ${r._customerId?.sh || ""}</p>
                                  <p><strong>Invoice No:</strong> ${r._subbranch?.branch_code}${r.invoice_no}</p>
                                  <p><strong>From - To:</strong> ${moment(r?.fromDate).format("DD/MM/YYYY")} - ${moment(r?.toDate).format("DD/MM/YYYY")}</p>
                                  <p><strong>Grand Total:</strong> ₹${Number(r.total_value).toFixed(2)}</p>
                                </div>
                                <p style="margin-top: 10px;">This will reload the invoice and send it to the customer.</p>
                              `,
                              icon: "question",
                              confirmButtonText: "Confirm",
                              showCancelButton: true,
                            }).then((result) => {
                              if (result.isConfirmed) {
                                mutateRegenInvoice(r.id, {
                                  onSuccess: () => {
                                    mutateSendInvoice({ customerId: r.customerId, invoice_no_c_b: r.id });
                                  },
                                });
                              }
                            });
                          }}
                          className="p-1 text-white rounded-sm bg-blue-700 hover:bg-blue-800"
                          title="Send Invoice"
                        >
                          <PaperAirplaneIcon className="h-4 w-4" />
                        </button>
                      </td>
                    )}
                    <td className="border border-slate-200 px-2 text-center">{r._customerId?.code}</td>
                    <td className="border border-slate-200 px-2 text-center min-w-[250px]">{r._customerId?.sh}</td>
                    <td className="border border-slate-200 px-2 text-center font-mono font-semibold">
                      {r._subbranch?.branch_code}
                      {r.invoice_no}
                    </td>
                    <td className="border border-slate-200 px-2 text-center font-mono font-semibold">
                      {r.total_i_tax > 0 ? `${r._subbranch?.branch_code}I${r.invoice_no}` : `-`}
                    </td>
                    <td className="border border-slate-200 px-2 text-center">{moment(r?.invDate).format("DD/MM/YYYY")}</td>
                    <td className="border border-slate-200 px-2 text-center">{moment(r?.fromDate).format("DD/MM/YYYY")}</td>
                    <td className="border border-slate-200 px-2 text-center">{moment(r?.toDate).format("DD/MM/YYYY")}</td>

                    <td className="border border-slate-200 px-2 text-center">
                      {r._customerId?.code}
                      {r._customerId?.pan?.substring(0, 5)}
                    </td>
                    <td className="border border-slate-200 px-2 pr-4 text-right">
                      {((Number(r.base_value) || 0) - (Number(r.total_fuelRate) || 0) - (Number(r.total_chcRate) || 0)).toFixed(2)}
                    </td>
                    <td className="border border-slate-200 px-2 pr-4 text-right">{Number(r.total_fuelRate).toFixed(2)}</td>
                    <td className="border border-slate-200 px-2 pr-4 text-right">{Number(r.total_chcRate).toFixed(2)}</td>
                    <td className="border border-slate-200 px-2 pr-4 text-right">{Number(r.total_d_tax * 0.09).toFixed(2)}</td>
                    <td className="border border-slate-200 px-2 pr-4 text-right">{Number(r.total_d_tax * 0.09).toFixed(2)}</td>
                    <td className="border border-slate-200 px-2 pr-4 text-right">{Number(r.total_i_tax * 0.18).toFixed(2)}</td>
                    {/*<td className="border border-slate-200 px-2 pr-4 text-right">{(Number(r.base_value) * 0.18).toFixed(2)}</td>*/}
                    <td className="border border-slate-200 px-2 pr-4 text-right">{Number(r.total_value).toFixed(2)}</td>
                    <td className="border border-slate-200 px-2 text-center">{r._customerId?.gst}</td>
                    <td className="border border-slate-200 px-2 text-center">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                        r.irn_status === "ACTIVE" ? "bg-green-200 text-green-800" :
                        r.irn_status === "PENDING" ? "bg-yellow-200 text-yellow-800" :
                        r.irn_status === "CANCELLED" ? "bg-red-200 text-red-800" :
                        "bg-gray-200 text-gray-600"
                      }`}>{r.irn_status || "N/A"}</span>
                    </td>
                    <td className="border border-slate-200 px-2 text-center">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                        r.irn_intl_status === "ACTIVE" ? "bg-green-200 text-green-800" :
                        r.irn_intl_status === "PENDING" ? "bg-yellow-200 text-yellow-800" :
                        r.irn_intl_status === "CANCELLED" ? "bg-red-200 text-red-800" :
                        "bg-gray-200 text-gray-600"
                      }`}>{r.irn_intl_status || "N/A"}</span>
                    </td>
                    <td className="border border-slate-200 px-2 text-center whitespace-nowrap">
                      <a
                        target="_blank"
                        href={BASE_URL + `/invoices_c/${r._subbranch?.branch_code}/${r._subbranch?.branch_code}${r.invoice_no}.pdf`}
                        className="text-white bg-red-900 px-2 py-1 rounded-md inline-block"
                      >
                        Invoice
                      </a>
                      <button
                        onClick={() => {
                          mutateGenerateExcel({ invoice_no_c_b: r.id, name: `${r._subbranch?.branch_code}${r.invoice_no}` });
                        }}
                        type="button"
                        className="text-white bg-green-800 px-2 py-1 ml-1 rounded-md"
                      >
                        Excel
                      </button>
                    </td>
                    {userDetails.roleName == roles.SUPER_ADMIN && (
                      <td className="border border-slate-200 px-2 text-center whitespace-nowrap">
                        {r.irn_status === "PENDING" && (
                          <button
                            onClick={() => mutateRetryIRN([r.id])}
                            className="ml-1 px-2 py-0.5 bg-yellow-600 text-white rounded-sm text-xs"
                            title="Retry IRN"
                          >
                            Retry IRN
                          </button>
                        )}
                        <button
                          onClick={() => {
                            mutateRegenInvoice(r.id);
                          }}
                          className="ml-2 px-2 py-0.5 bg-red-700 text-white rounded-sm"
                          disabled={r.irn_status === "ACTIVE" || r.irn_intl_status === "ACTIVE"}
                          title={r.irn_status === "ACTIVE" || r.irn_intl_status === "ACTIVE" ? "Cannot reload: IRN is active" : "Reload invoice"}
                          style={r.irn_status === "ACTIVE" || r.irn_intl_status === "ACTIVE" ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                        >
                          RELOAD
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            if (r.irn_status === "ACTIVE" || r.irn_intl_status === "ACTIVE") return;
                            setEditInvoiceId(r.id);
                            setEditInvoiceDate(r.invDate);
                          }}
                          className="ml-2 px-2 py-0.5 bg-primary text-white rounded-sm"
                          disabled={r.irn_status === "ACTIVE" || r.irn_intl_status === "ACTIVE"}
                          title={r.irn_status === "ACTIVE" || r.irn_intl_status === "ACTIVE" ? "Cannot edit: IRN is active" : "Edit invoice"}
                          style={r.irn_status === "ACTIVE" || r.irn_intl_status === "ACTIVE" ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                        >
                          EDIT
                        </button>
                      </td>
                    )}
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default InvoiceReport;
